import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-popup__inner" }
const _hoisted_2 = {
  key: 0,
  class: "as-popup__header"
}
const _hoisted_3 = { class: "as-popup__body" }

import { onMounted, onUnmounted, watch } from 'vue';


const __default__ = {};

interface IProps {
  title: String;
  wrapClass?: String;
  isShowPopup: Boolean;
  popupClass?: String;
  isShowHeader?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AsPopup',
  props: {
    title: {},
    wrapClass: {},
    isShowPopup: {},
    popupClass: {},
    isShowHeader: { type: Boolean, default: true }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

onMounted(() => {
  if(props.isShowPopup) {
    document.documentElement.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
  }
});

onUnmounted(() => {
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('overflow');
});

watch(() => props.isShowPopup, (newValue, _) => {
  if(newValue) {
    document.documentElement.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
  } else {
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }
});

const toggle = () => {
  emits("toggle");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-popup", [_ctx.popupClass, { 'as-popup__show': _ctx.isShowPopup }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass('as-popup__wrap ' + _ctx.wrapClass)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isShowHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
              _createElementVNode("button", {
                onClick: toggle,
                class: "as-popup__close"
              }, " ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      onClick: toggle,
      class: "as-popup__mask-overlay"
    })
  ], 2))
}
}

})